module.exports = __webpack_public_path__ + "static/media/10D.39ef422e.png";